import {StyleSheet} from "react-native";
import {styleVars} from "../../../app-style-vars";

export const styles = StyleSheet.create({
  wrapperContainer: {
    marginVertical: styleVars.rem(.5),
  },
  containerHidden: {
    display: 'none',
  },
  actionsStrip: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: styleVars.boschLightGrayW75,
    padding: styleVars.rem(.5),
  },
  triggerContainer: {
    maxWidth: '30%'
  },
  trigger: {
    color: styleVars.boschDarkBlue
  },
  triggerIcon: {
    paddingRight: styleVars.rem(.5),
    color: styleVars.boschDarkBlue,
  },
})